export default /* GraphQL */ `
    query GetMinimalListsAndInspirations {
        lists: minimalLists {
            isSelected
            listId
            name
            updated
            items {
                itemNo
                quantity
            }
        }
        inspirations: minimalInspirations {
            id
        }
    }
`;
